/* =============================================================
   Savage Design System · Categorical accent palette (JS layer)
   ----------------------------------------------------------------
   Decorative product/suite accent hues consumed as JS VALUES —
   places where a CSS custom property cannot go: alpha-composited
   inline styles (`${color}20`), chart configs, `<meta theme-color>`.
   Stylesheets keep using the --ds-* custom properties; this module
   is the same token contract projected into JS.

   These are ACCENTS, never status. Status colors (positive /
   warning / negative / info) stay on --ds-color-status-* and are
   reserved — see semantic.css.

   Variants are intentional: a hue may ship soft / bright / deep
   versions (multiple registered variations of one thing beat
   per-app improvisation). Add variants here, not hex in an app.

   Vendor-mandated brand hues (Google, Microsoft) do NOT live here —
   they belong to @savage-ds/brand (GOOGLE_BRAND).
============================================================= */

export const DS_ACCENTS = Object.freeze({
  blue: '#3b82f6',
  sky: '#0ea5e9',
  cyan: '#06b6d4',
  cyanBright: '#22d3ee',
  cyanDeep: '#0891b2',
  teal: '#14b8a6',
  emerald: '#10b981',
  emeraldDeep: '#059669',
  green: '#22c55e',
  yellow: '#eab308',
  amber: '#f59e0b',
  orange: '#f97316',
  red: '#ef4444',
  rose: '#f43f5e',
  pink: '#ec4899',
  pinkSoft: '#f472b6',
  fuchsia: '#d946ef',
  fuchsiaSoft: '#e879f9',
  purple: '#a855f7',
  purpleSoft: '#c084fc',
  violet: '#8b5cf6',
  violetDeep: '#7c3aed',
  violetSoft: '#a78bfa',
  indigo: '#6366f1',
  indigoSoft: '#818cf8',
  slate: '#64748b',
  slateSoft: '#94a3b8',
  gray: '#6b7280',
  blueSoft: '#60a5fa',
  greenSoft: '#34d399',
  greenBright: '#4ade80',
  redSoft: '#f87171',
  orangeSoft: '#fb923c',
  skySoft: '#38bdf8',
  gold: '#fbbf24',
  /* Ratified 2026-07-20 with the categorical-vocabulary decision
     (navigator queue entry "SEMANTIC/PALETTE color helpers"): the four
     legacy hues with real categorical roles and no prior DS home. */
  star: '#facc15',
  goldBright: '#ffd700',
  lime: '#84cc16',
  bronze: '#cd7f32',
});

/* Text-on-dark JS projection — same "CSS var cannot go here" rationale as
   DS_ACCENTS (inline HTML email styles), sourced from raw.css --text-on-dark
   / --text-muted-on-ink. */
export const DS_TEXT_ON_DARK = Object.freeze({
  primary: '#FAFAFA',
  muted: '#7A8A8A',
});
